import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icn-close.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0bd754cc")

_pushScopeId("data-v-0bd754cc")
const _hoisted_1 = { class: "dialog-overlay" }
const _hoisted_2 = { class: "dialog-box" }
const _hoisted_3 = { class: "dialog-top-area" }
const _hoisted_4 = { class: "dialog-top-area-title" }
const _hoisted_5 = { class: "dialog-top-area-title-text" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "dialog-top-area-button-image",
  src: _imports_0
}, null, -1)
const _hoisted_7 = { class: "dialog-body" }
const _hoisted_8 = { class: "dialog-body-text-input-area" }
const _hoisted_9 = { class: "dialog-body-text-input-area-title" }
const _hoisted_10 = { class: "dialog-body-text-input-area-title-text" }
const _hoisted_11 = { class: "dialog-body-append-button-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_Transition, { name: "dialog" }, {
      default: _withId(() => [
        _withDirectives(_createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("span", _hoisted_5, _toDisplayString(_ctx.titleText), 1)
              ]),
              _createVNode("div", {
                class: "dialog-top-area-button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeClicked(...args)))
              }, [
                _hoisted_6
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("span", _hoisted_10, _toDisplayString(_ctx.inputTitleText), 1)
                ]),
                _withDirectives(_createVNode("input", {
                  class: "dialog-body-text-input-area-input",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputFolderName = $event)),
                  placeholder: _ctx.placeHolderText
                }, null, 8, ["placeholder"]), [
                  [_vModelText, _ctx.inputFolderName]
                ])
              ]),
              _createVNode("div", {
                class: "dialog-body-append-button",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.appendClicked(...args)))
              }, [
                _createVNode("span", _hoisted_11, _toDisplayString(_ctx.buttonText), 1)
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.showDialog]
        ])
      ]),
      _: 1
    })
  ]))
})